/* MT/26 — collection + product page behaviour. Depends on mt-base.js (window.MT). */
(function () {
  'use strict';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function money(cents) { return (window.MT && MT.money) ? MT.money(cents) : '$' + (cents / 100).toFixed(2); }
  function q(sel, scope) { return (scope || document).querySelector(sel); }
  function qa(sel, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(sel)); }
  function initMT(scope) { if (window.MT && MT.init) MT.init(scope); }

  /* ============================================================ COLLECTION */
  function initCollection(section) {
    if (!section || section.dataset.mtReady) return;
    section.dataset.mtReady = '1';
    var sectionId = section.dataset.sectionId;
    var body = q('[data-mt-body]', section);
    var main = q('[data-mt-main]', section);
    var filters = q('[data-mt-filters]', section);
    var shade = q('.mt-filters-shade', section);
    var form = q('[data-mt-filter-form]', section);
    var desktop = function () { return window.matchMedia('(min-width: 990px)').matches; };

    /* --- desktop column toggle (persisted) --- */
    var key = 'mt-filters-open';
    var stored = localStorage.getItem(key);
    if (stored !== null && desktop() && body) body.classList.toggle('mt-coll__body--filters', stored === '1');
    function syncToggleLabel() {
      var btn = q('[data-mt-filters-toggle]', section), lab = q('[data-mt-filters-label]', section);
      if (!btn) return;
      var open = body.classList.contains('mt-coll__body--filters');
      btn.setAttribute('aria-expanded', desktop() ? String(open) : String(filters && filters.classList.contains('mt-open')));
      if (lab) lab.textContent = open ? 'Hide filters' : 'Show filters';
    }
    syncToggleLabel();

    function openDrawer() { if (!filters) return; filters.classList.add('mt-open'); if (shade) shade.classList.add('mt-open'); document.body.style.overflow = 'hidden'; }
    function closeDrawer() { if (!filters) return; filters.classList.remove('mt-open'); if (shade) shade.classList.remove('mt-open'); document.body.style.overflow = ''; }

    section.addEventListener('click', function (e) {
      var t = e.target.closest('[data-mt-filters-toggle]');
      if (t) {
        e.preventDefault();
        if (desktop()) { body.classList.toggle('mt-coll__body--filters'); localStorage.setItem(key, body.classList.contains('mt-coll__body--filters') ? '1' : '0'); syncToggleLabel(); }
        else openDrawer();
        return;
      }
      if (e.target.closest('[data-mt-filters-close]')) { if (!e.target.closest('[data-mt-ajax]')) e.preventDefault(); closeDrawer(); }
      var tab = e.target.closest('[data-mt-ftab]');
      if (tab) {
        qa('[data-mt-ftab]', section).forEach(function (b) { b.classList.toggle('mt-on', b === tab); });
        qa('[data-mt-fpane]', section).forEach(function (p) { p.hidden = p.dataset.mtFpane !== tab.dataset.mtFtab; });
      }
      var ajax = e.target.closest('a[data-mt-ajax]');
      if (ajax) { e.preventDefault(); load(ajax.href, true); }
      var next = e.target.closest('[data-mt-next]');
      if (next) { e.preventDefault(); loadMore(next); }
      var rm = e.target.closest('.mt-readmore-btn');
      if (rm) { var d = q('[data-mt-readmore]', section); d.classList.add('mt-expanded'); rm.remove(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

    /* --- filter form → URL --- */
    var debounce;
    function formUrl() {
      var params = new URLSearchParams(new FormData(form));
      Array.from(params.keys()).forEach(function (k) { if (params.get(k) === '' ) params.delete(k); });
      return section.dataset.url + '?' + params.toString();
    }
    if (form) {
      form.addEventListener('change', function (e) {
        clearTimeout(debounce);
        var wait = e.target.type === 'number' ? 700 : 80;
        debounce = setTimeout(function () { load(formUrl(), true); }, wait);
      });
      form.addEventListener('submit', function (e) { e.preventDefault(); load(formUrl(), true); });
    }
    section.addEventListener('change', function (e) {
      if (e.target.matches('[data-mt-sort]') || e.target.matches('[data-mt-sort-radio]')) {
        var url = new URL(form ? formUrl() : section.dataset.url, location.origin);
        url.searchParams.set('sort_by', e.target.value);
        var hidden = form && form.querySelector('[name="sort_by"]'); if (hidden) hidden.value = e.target.value;
        load(url.toString(), true);
      }
    });

    /* --- fetch + swap via Section Rendering API --- */
    var ctrl;
    function load(url, push) {
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      main.classList.add('mt-loading');
      var u = new URL(url, location.origin);
      u.searchParams.set('section_id', sectionId);
      fetch(u.toString(), { signal: ctrl.signal })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = q('[data-mt-collection]', doc);
          if (!fresh) { location.href = url; return; }
          var swap = ['[data-mt-main]', '[data-mt-applied]', '[data-mt-count]', '[data-mt-count-btn]', '[data-mt-count-eyebrow]', '[data-mt-filter-form]', '[data-mt-filters-toggle]'];
          swap.forEach(function (sel) {
            var a = q(sel, section), b = q(sel, fresh);
            if (a && b) {
              if (sel === '[data-mt-filter-form]') {
                // keep open/closed state of groups
                var openState = qa('.mt-fgroup', a).map(function (d) { return d.open; });
                qa('.mt-fgroup', b).forEach(function (d, i) { if (openState[i] !== undefined) d.open = openState[i]; });
              }
              a.replaceWith(b);
            }
          });
          form = q('[data-mt-filter-form]', section);
          if (form) {
            form.addEventListener('change', function (e) { clearTimeout(debounce); debounce = setTimeout(function () { load(formUrl(), true); }, e.target.type === 'number' ? 700 : 80); });
            form.addEventListener('submit', function (e) { e.preventDefault(); load(formUrl(), true); });
          }
          main = q('[data-mt-main]', section);
          var clean = new URL(url, location.origin); clean.searchParams.delete('section_id');
          if (push) history.replaceState({}, '', clean.toString());
          main.classList.remove('mt-loading');
          syncToggleLabel();
          initMT(main);
          if (window.PlSwatches && PlSwatches.init) { try { PlSwatches.init(); } catch (e) {} }
          document.dispatchEvent(new CustomEvent('mt:collection:updated', { detail: { section: section } }));
          if (!desktop()) { var top = q('[data-mt-toolbar]', section); if (top) window.scrollTo({ top: top.getBoundingClientRect().top + window.scrollY - 8, behavior: 'smooth' }); }
        })
        .catch(function (err) { if (err.name !== 'AbortError') { main.classList.remove('mt-loading'); location.href = url; } });
    }

    /* --- load more (append next page) --- */
    function loadMore(btn) {
      btn.classList.add('mt-loading');
      var u = new URL(btn.href, location.origin);
      u.searchParams.set('section_id', sectionId);
      fetch(u.toString()).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = q('[data-mt-grid]', section), newGrid = q('[data-mt-grid]', doc);
        if (!grid || !newGrid) { location.href = btn.href; return; }
        var items = Array.from(newGrid.children);
        items.forEach(function (el, i) { el.classList.add('mt-reveal'); el.style.transitionDelay = (i % 8) * 40 + 'ms'; grid.appendChild(el); });
        var wrap = q('[data-mt-loadmore]', section), newWrap = q('[data-mt-loadmore]', doc);
        if (wrap && newWrap) {
          var shown = grid.querySelectorAll('.mt-card').length, total = parseInt(section.dataset.total, 10) || shown;
          var s = q('[data-mt-shown]', newWrap); if (s) s.textContent = shown;
          var p = q('[data-mt-progress]', newWrap); if (p) p.style.width = Math.min(100, Math.round(shown / total * 100)) + '%';
          wrap.replaceWith(newWrap);
        } else if (wrap) wrap.remove();
        var clean = new URL(btn.href, location.origin); clean.searchParams.delete('section_id');
        history.replaceState({}, '', clean.toString());
        initMT(grid);
        if (window.PlSwatches && PlSwatches.init) { try { PlSwatches.init(); } catch (e) {} }
      }).catch(function () { location.href = btn.href; });
    }

    /* --- mobile read more on SEO text --- */
    var desc = q('[data-mt-readmore]', section);
    if (desc && !desktop() && desc.scrollHeight > desc.clientHeight + 8) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'mt-readmore-btn'; b.textContent = 'Read more';
      desc.after(b);
    }
  }

  /* ============================================================ PRODUCT */
  function initProduct(section) {
    if (!section || section.dataset.mtReady) return;
    section.dataset.mtReady = '1';
    var variants, options, form, picker, idInput, atc, sticky, bundle;
    function readRefs() {
      variants = JSON.parse(q('[data-mt-variants]', section).textContent);
      options = JSON.parse(q('[data-mt-options]', section).textContent);
      form = q('[data-mt-form]', section);
      picker = q('[data-mt-variant-picker]', section);
      idInput = q('[data-mt-variant-id]', section);
      atc = q('[data-mt-atc]', section);
      sticky = q('[data-mt-sticky]', section);
      bundle = q('[data-mt-bundle]', section);
    }
    readRefs();

    function selectedOptions() {
      if (!picker) return null;
      return qa('.mt-vp__group', picker).map(function (g) { var c = g.querySelector('input:checked'); return c ? c.value : null; });
    }
    function findVariant(opts) {
      return variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
    }
    function currentVariant() {
      var opts = selectedOptions();
      if (!opts) return variants.find(function (v) { return String(v.id) === idInput.value; }) || variants[0];
      return findVariant(opts) || null;
    }

    /* mark unavailable option values given the other selections */
    function markAvailability() {
      if (!picker) return;
      var sel = selectedOptions();
      qa('.mt-vp__group', picker).forEach(function (g, gi) {
        qa('input', g).forEach(function (inp) {
          var test = sel.slice(); test[gi] = inp.value;
          var v = findVariant(test);
          var exists = variants.some(function (x) { return x.options[gi] === inp.value; });
          inp.classList.toggle('mt-unavailable', !exists || (v ? !v.available : true));
        });
        var em = g.querySelector('[data-mt-option-value]'); var c = g.querySelector('input:checked'); if (em && c) em.textContent = c.value;
      });
    }

    function render() {
      var v = currentVariant();
      markAvailability();
      var price = q('[data-mt-price]', section), cmp = q('[data-mt-compare]', section), save = q('[data-mt-save]', section), saveAmt = q('[data-mt-save-amount]', section);
      var atcLabel = q('[data-mt-atc-label]', section), atcPrice = q('[data-mt-atc-price]', section), hint = q('[data-mt-size-hint]', section), saleTag = q('[data-mt-sale-tag]', section);
      var qty = parseInt((q('[data-mt-qty]', section) || {}).value, 10) || 1;
      if (!v) {
        if (atc) { atc.disabled = true; } if (atcLabel) atcLabel.textContent = 'Unavailable';
        if (sticky) { var sb = q('[data-mt-sticky-atc]', sticky); sb.disabled = true; sb.textContent = 'Unavailable'; }
        return;
      }
      idInput.value = v.id;
      if (price) price.textContent = money(v.price);
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      if (cmp) { cmp.textContent = money(v.compare_at_price || 0); cmp.hidden = !onSale; }
      if (save) { save.hidden = !onSale; if (saveAmt && onSale) saveAmt.textContent = money(v.compare_at_price - v.price); }
      if (saleTag) { saleTag.hidden = !onSale; if (onSale) saleTag.textContent = 'Save ' + Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100) + '%'; }
      if (atc) atc.disabled = !v.available;
      if (atcLabel) atcLabel.textContent = v.available ? (atc.dataset.label || atcLabel.dataset.label || atcLabel.textContent.replace(/Sold out/i, 'Add to cart')) : 'Sold out';
      if (atcPrice) atcPrice.textContent = money(v.price * qty);
      if (hint) { hint.classList.toggle('mt-warn', !v.available); hint.textContent = v.available ? hint.dataset.default : 'This size is sold out — pick another or check back soon.'; }
      if (sticky) {
        var sp = q('[data-mt-sticky-price]', sticky), sb2 = q('[data-mt-sticky-atc]', sticky), si = q('[data-mt-sticky-img]', sticky);
        if (sp) sp.textContent = money(v.price); if (sb2) { sb2.disabled = !v.available; sb2.textContent = v.available ? 'Add to cart' : 'Sold out'; }
        if (si && v.featured_image && v.featured_image.src) si.src = v.featured_image.src.replace(/(\.[a-z]+)(\?|$)/, '_120x$1$2');
      }
      if (bundle) {
        bundle.dataset.basePrice = v.price;
        var mp = q('[data-mt-bundle-main-price]', bundle); if (mp) mp.textContent = money(v.price);
        var total = v.price; qa('[data-mt-bundle-addon]', bundle).forEach(function (a) { total += parseInt(a.dataset.price, 10) || 0; });
        var disc = parseInt(bundle.dataset.discount, 10) || 0;
        var tb = q('[data-mt-bundle-total]', bundle), tw = q('[data-mt-bundle-was]', bundle);
        if (tb) tb.textContent = money(Math.round(total * (100 - disc) / 100)); if (tw) tw.textContent = money(total);
      }
      // scroll gallery to variant image (mobile) / URL
      if (v.featured_media) {
        var tile = q('[data-media-id="' + v.featured_media.id + '"]', section), track = q('[data-mt-gallery-track]', section);
        if (tile && track && !window.matchMedia('(min-width: 990px)').matches) track.scrollTo({ left: tile.offsetLeft - 16, behavior: 'smooth' });
      }
      var url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url.toString());
    }
    function bindPicker() {
      if (atc) { var l0 = q('[data-mt-atc-label]', section); if (l0) l0.dataset.label = l0.textContent.trim() === 'Sold out' ? 'Add to cart' : l0.textContent.trim(); }
      if (picker && !picker.dataset.mtBound) { picker.dataset.mtBound = '1'; picker.addEventListener('change', render); }
      render();
    }
    bindPicker();
    /* re-read product data after a soft product swap (DOM morphed in place) */
    section._mtRefresh = function () {
      readRefs(); bindPicker(); bindGallery();
      if (sticky) { sticky.hidden = false; bindStickyClick(); }
      applySticky();
    };

    /* qty */
    section.addEventListener('click', function (e) {
      var inp = q('[data-mt-qty]', section);
      if (e.target.closest('[data-mt-qty-minus]') && inp) { inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) - 1); render(); }
      if (e.target.closest('[data-mt-qty-plus]') && inp) { inp.value = (parseInt(inp.value, 10) || 1) + 1; render(); }
    });
    var qi = q('[data-mt-qty]', section); if (qi) qi.addEventListener('change', render);

    /* add to cart (ajax) */
    function addItems(items, btn) {
      btn && btn.classList.add('mt-loading');
      return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) throw r; return r.json(); })
        .then(function () {
          btn && btn.classList.remove('mt-loading');
          if (btn && btn.classList.contains('mt-pdp__atc')) { btn.classList.add('mt-added'); var l = q('[data-mt-atc-label]', btn); var old = l && l.textContent; if (l) l.textContent = 'Added ✓'; setTimeout(function () { btn.classList.remove('mt-added'); if (l) l.textContent = old; }, 1600); }
          if (window.MT && MT.openCart) MT.openCart(); else location.href = root + 'cart';
        })
        .catch(function (err) {
          btn && btn.classList.remove('mt-loading');
          if (err && err.json) err.json().then(function (j) { alert(j.description || j.message || 'Could not add to cart'); });
          else form && form.submit();
        });
    }
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = currentVariant(); if (!v || !v.available) return;
      var qty = parseInt((q('[data-mt-qty]', section) || {}).value, 10) || 1;
      addItems([{ id: v.id, quantity: qty }], atc);
    });
    function bindStickyClick() {
      var sb = sticky && q('[data-mt-sticky-atc]', sticky);
      if (sb && !sb.dataset.mtBound) { sb.dataset.mtBound = '1'; sb.addEventListener('click', function () { if (form) form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true })); }); }
    }
    if (sticky) {
      bindStickyClick();
      sticky.hidden = false;
      var target = atc || q('.mt-pdp__buy', section);
      if ('IntersectionObserver' in window && target) {
        new IntersectionObserver(function (en) { var s = q('[data-mt-sticky]', section); if (s) s.classList.toggle('mt-show', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }, { threshold: 0 }).observe(target);
      }
    }
    if (bundle) {
      q('[data-mt-bundle-add]', bundle).addEventListener('click', function () {
        var v = currentVariant(); if (!v || !v.available) return;
        var items = [{ id: v.id, quantity: 1 }];
        qa('[data-mt-bundle-addon]', bundle).forEach(function (a) { items.push({ id: parseInt(a.dataset.variantId, 10), quantity: 1 }); });
        addItems(items, this);
      });
    }

    /* gallery: dots (mobile) + zoom (desktop) */
    function bindGallery() {
      var track = q('[data-mt-gallery-track]', section), dots = qa('[data-mt-gallery-dots] span', section);
      if (!track || !dots.length || track.dataset.mtBound) return;
      track.dataset.mtBound = '1';
      var tiles = qa('.mt-pdp__tile', track), raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var x = track.scrollLeft + track.clientWidth * 0.3, idx = 0;
          tiles.forEach(function (t, i) { if (t.offsetLeft - 16 <= x) idx = i; });
          dots.forEach(function (d, i) { d.classList.toggle('mt-on', i === idx); });
        });
      }, { passive: true });
    }
    bindGallery();
    var zoom = q('[data-mt-zoom-modal]', section);
    if (zoom) {
      section.addEventListener('click', function (e) {
        var t = e.target.closest('[data-mt-zoom]');
        if (t && window.matchMedia('(min-width: 990px)').matches) { if (zoom.parentNode !== document.body) document.body.appendChild(zoom); q('[data-mt-zoom-img]', zoom).src = t.dataset.mtZoom; zoom.hidden = false; document.body.style.overflow = 'hidden'; }
      });
    }
    /* sticky buy column: stays pinned (ATC visible) while the gallery scrolls; once the gallery is scrolled through,
       the column scrolls with the page to reveal the rest. Works even when the column is taller than the viewport. */
    function applySticky() {
      var layout = q('.mt-pdp__layout', section), gallery = q('.mt-pdp__gallery', section), buyCol = q('.mt-pdp__buy', section);
      if (!layout || !gallery || !buyCol) return;
      var mode = section.dataset.stickyMode || 'auto';
      var desk = window.matchMedia('(min-width: 990px)').matches;
      layout.classList.toggle('mt-pdp__layout--no-sticky', mode === 'none');
      layout.classList.toggle('mt-pdp__layout--gallery-sticky', mode === 'gallery');
      if (!desk || mode === 'none' || mode === 'gallery') { layout.style.minHeight = ''; gallery.style.position = ''; gallery.style.top = ''; return; }
      var V = window.innerHeight, B = buyCol.offsetHeight, G = gallery.offsetHeight, more = q('.mt-pdp__more', section);
      var left = G + (more ? more.offsetHeight + 40 : 0);
      /* gallery: pinned at the top when it fits; otherwise it scrolls until its bottom meets the viewport bottom and stays there
         (so the left side never goes blank while the buy column keeps scrolling) */
      if (!more) { gallery.style.position = 'sticky'; gallery.style.top = (G <= V - 32 ? 16 : V - G - 16) + 'px'; }
      else { gallery.style.position = ''; gallery.style.top = ''; }
      if (B <= V - 32) { layout.style.minHeight = ''; return; }              /* buy column fits the screen: plain sticky */
      var pin = Math.max(0, left - (V - 16));                                /* keep the buy column pinned until the gallery's bottom reaches the viewport bottom */
      layout.style.minHeight = (B + 16 + pin) + 'px';
    }
    applySticky();
    window.addEventListener('resize', applySticky, { passive: true });
    window.addEventListener('load', applySticky);
    setTimeout(applySticky, 1500);
    if ('ResizeObserver' in window) { var ro = new ResizeObserver(function () { applySticky(); }); var bc = q('.mt-pdp__buy', section), gl = q('.mt-pdp__gallery', section); if (bc) ro.observe(bc); if (gl) ro.observe(gl); }
    section.addEventListener('toggle', function () { setTimeout(applySticky, 50); }, true);

    /* move an app widget (e.g. coupon block) under the price — keeps watching, apps re-render on variant change */
    var couponSel = (section.dataset.couponSelector || '').trim(), anchor = q('[data-mt-coupon-anchor]', section);
    if (couponSel && anchor) {
      var mo, raf;
      function findCoupon() {
        try {
          var cands = Array.prototype.filter.call(document.querySelectorAll(couponSel), function (n) { return !/^(SCRIPT|STYLE|LINK|TEMPLATE|META)$/.test(n.tagName) && !anchor.contains(n) && (n.children.length || (n.textContent || '').trim()); });
          return cands.filter(function (n) { return n.closest('[data-mt-product]') === section; })[0] || cands[0] || null;
        } catch (e) { return null; }
      }
      function moveCoupon() {
        var el = findCoupon();
        if (!el) return;
        var top = el; while (top.parentElement && top.parentElement !== document.body && top.parentElement.children.length === 1 && !top.parentElement.matches('[data-mt-product], .mt-pdp__buy, .mt-pdp__buy-block, form, .mt-pdp__dynamic')) top = top.parentElement;
        while (anchor.firstChild) anchor.removeChild(anchor.firstChild);
        anchor.appendChild(top);
        applySticky();
      }
      moveCoupon();
      if ('MutationObserver' in window) {
        mo = new MutationObserver(function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(moveCoupon); });
        mo.observe(document.body, { childList: true, subtree: true });
      }
    }

    /* color swatches injected by the Platmart app: keep them right above the size picker */
    function placeSwatches() {
      var picker = q('.mt-vp', section); if (!picker) return;
      var buy = q('.mt-pdp__buy', section); if (!buy) return;
      var nodes = qa('a[href*="/products/"], a[href^="javascript"]', buy).map(function (a) {
        var top = a; while (top.parentElement && top.parentElement !== buy && !top.parentElement.matches('.mt-pdp__buy-block, form')) top = top.parentElement;
        return top;
      });
      var seen = [];
      nodes.forEach(function (top) {
        if (!top || seen.indexOf(top) !== -1) return; seen.push(top);
        var cls = typeof top.className === 'string' ? top.className : '';
        if (/(^|\s)mt-/.test(cls) || top.matches('form, .mt-pdp__buy-block')) return;
        if (!/pl-|swatch|color/i.test(cls + ' ' + (top.id || '') + ' ' + top.textContent.slice(0, 40))) return;
        if (top.nextElementSibling !== picker) picker.parentNode.insertBefore(top, picker);
      });
    }
    placeSwatches();
    /* Kiwi "Size Chart" link: sits at the right of the SIZE label (replaces our size guide button) */
    function placeSizeChart() {
      var legend = q('.mt-vp__group--size .mt-vp__legend', section); if (!legend) return;
      var el = Array.prototype.filter.call(section.querySelectorAll('a, button, span, div, p'), function (n) { return /^\s*size\s*chart\s*$/i.test(n.textContent || '') && !n.closest('.mt-vp__legend'); })[0];
      if (!el) return;
      var top = el; while (top.parentElement && !top.parentElement.matches('[data-mt-product], .mt-pdp__buy, .mt-pdp__buy-block, .mt-pdp__more, form, .mt-vp, .mt-vp__group, .mt-vp__legend')) top = top.parentElement;
      if (top.closest('.mt-vp__legend') || /(^|\s)mt-/.test(typeof top.className === 'string' ? top.className : '')) return;
      top.classList.add('mt-vp__sizechart');
      legend.appendChild(top);
    }
    placeSizeChart();
    if ('MutationObserver' in window) { var swRaf; new MutationObserver(function () { cancelAnimationFrame(swRaf); swRaf = requestAnimationFrame(function () { placeSwatches(); placeSizeChart(); }); }).observe(section, { childList: true, subtree: true }); }

    /* make videos actually autoplay (some browsers need a nudge) */
    qa('video', section).forEach(function (v) { v.muted = true; v.loop = true; v.autoplay = true; v.playsInline = true; v.removeAttribute('controls'); var p = v.play(); if (p && p.catch) p.catch(function () {}); });
  }

  /* ============================================================ soft navigation between sibling products (color swatch links) */
  /* morph the product section in place: swap product-specific blocks, keep app-injected widgets (swatches, coupon, EDD, size chart) */
  function morphProduct(oldSec, freshSec) {
    ['data-product-handle', 'data-url'].forEach(function (a) { if (freshSec.hasAttribute(a)) oldSec.setAttribute(a, freshSec.getAttribute(a)); });
    ['[data-mt-variants]', '[data-mt-options]'].forEach(function (sel) { var o = q(sel, oldSec), f = q(sel, freshSec); if (o && f) o.textContent = f.textContent; });
    var oc = q('.mt-pdp__crumbs', oldSec), fc = q('.mt-pdp__crumbs', freshSec); if (oc && fc) oc.innerHTML = fc.innerHTML;
    var og = q('.mt-pdp__gallery', oldSec), fg = q('.mt-pdp__gallery', freshSec); if (og && fg) og.replaceWith(fg);
    var os = q('[data-mt-sticky]', oldSec), fs = q('[data-mt-sticky]', freshSec); if (os && fs) os.replaceWith(fs);
    var om = q('.mt-pdp__more', oldSec), fm = q('.mt-pdp__more', freshSec);
    if (om && fm) om.replaceWith(fm); else if (om && !fm) om.remove(); else if (!om && fm) { var lay = q('.mt-pdp__layout', oldSec); if (lay) lay.appendChild(fm); }
    var oldBuy = q('.mt-pdp__buy', oldSec), freshBuy = q('.mt-pdp__buy', freshSec);
    if (!oldBuy || !freshBuy) return false;
    var keyOf = function (el) { return el.getAttribute('data-mt-coupon-anchor') !== null ? 'coupon' : (el.className || el.tagName).split(' ')[0]; };
    var oldKids = Array.prototype.slice.call(oldBuy.children), cursor = -1, matched = [];
    Array.prototype.slice.call(freshBuy.children).forEach(function (f) {
      var key = keyOf(f), idx = -1;
      for (var i = cursor + 1; i < oldKids.length; i++) { if (oldKids[i].parentNode === oldBuy && keyOf(oldKids[i]) === key) { idx = i; break; } }
      if (idx === -1) { /* new block: insert after the current cursor */
        var ref = cursor >= 0 ? oldKids[cursor] : null;
        if (ref && ref.parentNode === oldBuy) ref.after(f); else oldBuy.insertBefore(f, oldBuy.firstChild);
        oldKids.splice(cursor + 1, 0, f); cursor += 1; matched.push(f); return;
      }
      var o = oldKids[idx]; cursor = idx; matched.push(o);
      if (key === 'coupon' || key === 'mt-pdp__app' || key === 'mt-modal') return;               /* app-managed or static: keep */
      if (key === 'mt-pdp__buy-block') {                                                           /* keep the form (apps inject around it), patch product bits */
        var oi = q('[data-mt-variant-id]', o), fi = q('[data-mt-variant-id]', f); if (oi && fi) oi.value = fi.value;
        var oa = q('.mt-pdp__atc', o), fa = q('.mt-pdp__atc', f); if (oa && fa) { oa.innerHTML = fa.innerHTML; oa.disabled = fa.disabled; }
        var od = q('.mt-pdp__dynamic', o), fd = q('.mt-pdp__dynamic', f); if (od && fd) od.replaceWith(fd);
        var of = q('form', o), ff = q('form', f); if (of && ff) { of.id = ff.id; }
        return;
      }
      /* keep widgets that apps injected inside our block (size chart link, color swatches): move them right after the new block */
      var foreign = Array.prototype.filter.call(o.children, function (c) { var cls = (typeof c.className === 'string' ? c.className : '') + ' ' + (c.id || ''); return cls.trim() && !/(^|\s)mt-/.test(cls) && !/jdgm-preview/.test(cls); });
      o.replaceWith(f); oldKids[idx] = f; matched.push(f);
      foreign.reverse().forEach(function (c) { f.after(c); });
    });
    /* product-specific blocks that the new product does not have (e.g. badge) are removed */
    oldKids.forEach(function (o) {
      if (!o.parentNode || matched.indexOf(o) !== -1) return;
      if (/^(mt-pdp__title|mt-pdp__price|mt-gsm|mt-vp|mt-pdp__badge|mt-pdp__text|mt-acc|mt-bundle|mt-coupon)$/.test(keyOf(o))) o.remove();
    });
    return true;
  }
  function markActiveSwatch(buy, url) {
    try {
      var path = new URL(url, location.origin).pathname;
      qa('a[href]', buy).forEach(function (a) {
        if (!/\/products\//.test(a.getAttribute('href') || '')) return;
        var on = a.pathname === path;
        a.classList.toggle('mt-swatch-current', on);
        if (on) a.setAttribute('aria-current', 'page'); else a.removeAttribute('aria-current');
      });
    } catch (e) {}
  }
  var swapping = false;
  function softNavigate(url) {
    var main = q('[data-mt-product]');
    var ids = qa('[data-mt-product], [data-mt-section-swap]').map(function (el) { return el.dataset.sectionId; }).filter(Boolean);
    if (!ids.length || !main || swapping) { location.href = url; return; }
    swapping = true;
    var u = new URL(url, location.origin); u.searchParams.set('sections', ids.join(','));
    document.documentElement.classList.add('mt-pdp-swapping');
    var oldLayout = q('.mt-pdp__layout'), anchorTop = oldLayout ? oldLayout.getBoundingClientRect().top : null;
    fetch(u.toString(), { headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (json) {
        var h1before = (q('.mt-pdp__h1') || {}).textContent || '';
        qa('body > .mt-modal').forEach(function (mm) { if (/^MT(WeightGuide|SizeGuide)-/.test(mm.id || '')) mm.remove(); });
        var mainId = main.dataset.sectionId, ok = false;
        ids.forEach(function (id) {
          var html = json[id]; if (!html) return;
          var holder = document.getElementById('shopify-section-' + id);
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.getElementById('shopify-section-' + id) || doc.body.firstElementChild;
          if (!holder || !fresh) return;
          if (id === mainId) { var freshSec = q('[data-mt-product]', fresh); ok = freshSec ? morphProduct(main, freshSec) : false; }
          else holder.replaceWith(fresh);
        });
        var h1 = q('.mt-pdp__h1');
        if (!ok || !h1 || h1.textContent === h1before) { location.href = url; return; }
        var clean = new URL(url, location.origin); clean.searchParams.delete('sections');
        history.pushState({ mtSoft: true }, '', clean.toString());
        document.title = h1.textContent.trim() + document.title.replace(/^[^|\u2013\u2014-]*/, '');
        function restore() {
          var layout = q('.mt-pdp__layout');
          if (!layout || anchorTop === null) return;
          var d = layout.getBoundingClientRect().top - anchorTop;
          if (Math.abs(d) > 1) window.scrollBy(0, d);
        }
        restore();
        if (main._mtRefresh) main._mtRefresh();
        boot(document); initMT(document);
        markActiveSwatch(q('.mt-pdp__buy', main), clean.toString());
        if (window.Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init) { try { Shopify.PaymentButton.init(); } catch (e) {} }
        [60, 200, 500].forEach(function (t) { setTimeout(restore, t); });
        document.dispatchEvent(new CustomEvent('mt:product:swapped', { detail: { url: clean.toString() } }));
      })
      .catch(function () { location.href = url; })
      .then(function () { swapping = false; requestAnimationFrame(function () { document.documentElement.classList.remove('mt-pdp-swapping'); }); });
  }
  function urlFromSwatch(target, boundary) {
    var node = target, url = null;
    while (node && node !== boundary && node.nodeType === 1) {
      var href = node.tagName === 'A' ? (node.getAttribute('href') || '') : '';
      if (/\/products\//.test(href)) { url = node.href; break; }
      var ds = node.dataset || {};
      for (var k in ds) { if (typeof ds[k] === 'string' && /\/products\//.test(ds[k])) { url = ds[k]; break; } }
      if (!url && ds.productHandle) url = root + 'products/' + ds.productHandle;
      if (!url && ds.handle && /pl-|swatch/i.test(node.className || '')) url = root + 'products/' + ds.handle;
      if (url) break;
      node = node.parentElement;
    }
    return url;
  }
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    var buy = e.target.closest && e.target.closest('.mt-pdp__buy');
    if (!buy || !q('[data-mt-product]')) return;
    if (e.target.closest('.mt-rte, .mt-bundle, .mt-pdp__custom, .mt-pdp__app, [data-mt-coupon-anchor], .mt-vp, .mt-acc, .mt-pdp__cta, .mt-pdp__dynamic, .mt-coupon')) return;
    var url = urlFromSwatch(e.target, buy);
    if (!url) return;
    try { url = new URL(url, location.origin).href; } catch (err) { return; }
    if (url.split('?')[0] === location.href.split('?')[0]) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (window.console && console.debug) console.debug('[MT] soft navigation \u2192', url);
    softNavigate(url);
  }, true);
  window.addEventListener('popstate', function (e) { if (e.state && e.state.mtSoft || (history.state && history.state.mtSoft)) location.reload(); });

  /* ============================================================ modals (generic) */
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-mt-modal-open]');
    if (o) { var m = document.getElementById(o.dataset.mtModalOpen); if (m) { if (m.parentNode !== document.body) document.body.appendChild(m); m.hidden = false; document.body.style.overflow = 'hidden'; } }
    if (e.target.closest('[data-mt-modal-close]')) { var mm = e.target.closest('.mt-modal'); if (mm) { mm.hidden = true; document.body.style.overflow = ''; } }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') qa('.mt-modal:not([hidden])').forEach(function (m) { m.hidden = true; document.body.style.overflow = ''; }); });

  /* ============================================================ recommendations */
  function initRecs(el) {
    if (!el || el.dataset.mtReady) return; el.dataset.mtReady = '1';
    fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = q('[data-mt-recs]', doc);
      if (fresh && fresh.querySelector('.mt-card')) { el.innerHTML = fresh.innerHTML; initMT(el); if (window.PlSwatches && PlSwatches.init) { try { PlSwatches.init(); } catch (e) {} } }
      else el.remove();
    }).catch(function () {});
  }

  /* ============================================================ boot */
  function boot(scope) {
    qa('[data-mt-collection]', scope).forEach(initCollection);
    qa('[data-mt-product]', scope).forEach(initProduct);
    qa('[data-mt-recs]', scope).forEach(initRecs);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (e) { delete e.target.dataset.mtReady; boot(e.target.parentNode || document); });
})();
